module.exports = __webpack_public_path__ + "static/media/leaguesafe.238f8c6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/desktop/leaguesafe.svg
// module id = 106
// module chunks = 0